import { getLoginType } from '../../utils/commonFunctions';
export const setUserState = (data, loginId) => {
	let loginType = getLoginType(loginId, data.social_domain);
	let {
		token,
		user_name,
		user_pic,
		user_id,
		new_user,
		is_olympiad,
		is_retail,
		activeCourseId,
		onboarding,
		support_email,
		support_phone,
		full_name
	} = data;

	const processedData = {
		token,
		userName: user_name,
		fullName: full_name,
		userPic: user_pic,
		userId: user_id,
		newUser: new_user,
		isOlympiad: is_olympiad,
		isRetail: is_retail,
		loginType,
		courseId: activeCourseId,
		onboarding,
		supportEmail: support_email || 'info@steptest.in',
		supportPhone: support_phone || '9789883344',
	};
	localStorage.setItem('token', token);
	return processedData;
};
